var _path, _path2, _path3, _path4, _circle, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyTeam({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.8353 90.5273V83.1438C99.8353 79.2273 98.2795 75.4712 95.5101 72.7019C92.7408 69.9325 88.9847 68.3767 85.0682 68.3767H55.5341C51.6177 68.3767 47.8616 69.9325 45.0922 72.7019C42.3229 75.4712 40.7671 79.2273 40.7671 83.1438V90.5273",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3012 53.6096C78.4568 53.6096 85.0682 46.9981 85.0682 38.8425C85.0682 30.6869 78.4568 24.0754 70.3012 24.0754C62.1456 24.0754 55.5341 30.6869 55.5341 38.8425C55.5341 46.9981 62.1456 53.6096 70.3012 53.6096Z",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8353 90.5273V83.1438M41.8242 68.3767H35.5341C31.6177 68.3767 27.8616 69.9325 25.0922 72.7019C22.3229 75.4712 20.7671 79.2273 20.7671 83.1438V90.5273",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3242 25.3555C54.4848 24.5329 52.4464 24.0754 50.3012 24.0754C42.1456 24.0754 35.5341 30.6869 35.5341 38.8425C35.5341 46.9981 42.1456 53.6096 50.3012 53.6096C52.4464 53.6096 54.4848 53.1521 56.3242 52.3295",
    stroke: "black",
    strokeWidth: 3.85228,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.181,
    cy: 91.8503,
    r: 22.6428,
    fill: "#FF4A01",
    stroke: "black",
    strokeWidth: 1.96894,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.737 84.9301C110.313 84.3534 110.313 83.4184 109.737 82.8417C109.16 82.265 108.225 82.265 107.648 82.8417L100.453 90.0372L93.2575 82.8419C92.6808 82.2652 91.7458 82.2652 91.1692 82.8419C90.5925 83.4186 90.5925 84.3536 91.1692 84.9302L98.3644 92.1255L91.1692 99.3208C90.5925 99.8975 90.5925 100.833 91.1692 101.409C91.7458 101.986 92.6808 101.986 93.2575 101.409L100.453 94.2139L107.648 101.409C108.225 101.986 109.16 101.986 109.737 101.409C110.313 100.833 110.313 99.8977 109.737 99.321L102.541 92.1255L109.737 84.9301Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyTeam);
export default __webpack_public_path__ + "static/media/emptyTeam.cf21f12c43f6e1fa6b1670aa58a7eb11.svg";
export { ForwardRef as ReactComponent };